import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, CheckCircle2Icon } from 'lucide-react';
export function AudienceSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const problems = ['Pasás horas organizando cada sesión desde cero', 'No sabés cómo estructurar evaluaciones y protocolos correctamente', 'Te cuesta organizar el seguimiento de tus pacientes', 'Muchas veces improvisás ejercicios y tratamientos en el momento', 'Sentís que te faltan herramientas profesionales para ser más eficiente'];
  const solutions = ['Planificar sesiones profesionales en minutos', 'Registrar el progreso de tus pacientes de forma clara', 'Organizar todo tu trabajo clínico con un sistema probado', 'Tener protocolos y ejercicios listos para cada sesión'];
  return <section className="w-full px-4 py-20 bg-gradient-to-b from-[#1e293b] to-[#0f172a]" data-id="element-10">
      <div className="max-w-4xl mx-auto" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-12">
          <h2 className="text-3xl md:text-5xl font-black mb-12 text-center leading-tight" data-id="element-13">
            ¿Sos kinesiólogo y te pasa alguna de estas situaciones?
          </h2>

          <div className="space-y-4 mb-16" data-id="element-14">
            {problems.map((problem, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.08 * index
          }} className="flex items-start gap-3 bg-white/5 border border-white/10 p-4 rounded-lg" data-id="element-15">
                <XCircleIcon className="w-6 h-6 text-[#ef4444] flex-shrink-0 mt-0.5" data-id="element-16" />
                <span className="text-lg text-gray-300" data-id="element-17">{problem}</span>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-18">
            <h3 className="text-2xl md:text-4xl font-black mb-8 text-center text-yellow-400" data-id="element-19">
              Con MegaPack KineEficiente vas a poder:
            </h3>

            <div className="space-y-4 mb-12" data-id="element-20">
              {solutions.map((solution, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.08 * index
            }} className="flex items-start gap-3 bg-yellow-400/10 border border-yellow-400/20 p-4 rounded-lg" data-id="element-21">
                  <CheckCircle2Icon className="w-6 h-6 text-yellow-400 flex-shrink-0 mt-0.5" data-id="element-22" />
                  <span className="text-lg text-white font-medium" data-id="element-23">
                    {solution}
                  </span>
                </motion.div>)}
            </div>

            <p className="text-xl md:text-2xl font-bold text-center text-gray-300 mb-10" data-id="element-24">
              MegaPack KineEficiente fue creado para resolver exactamente estos
              problemas.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}